import { render, staticRenderFns } from "./Compression.vue?vue&type=template&id=01843cb3&scoped=true"
import script from "./Compression.vue?vue&type=script&lang=js"
export * from "./Compression.vue?vue&type=script&lang=js"
import style0 from "./Compression.vue?vue&type=style&index=0&id=01843cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01843cb3",
  null
  
)

export default component.exports